/**
 * Realtime ASR (FunASR) service settings.
 * Override at build time with VUE_APP_ASR_URL / VUE_APP_ASR_TOKEN.
 * Note: the token ships in the frontend bundle, so it only limits casual use.
 */
export const ASR_URL = process.env.VUE_APP_ASR_URL || 'wss://yy2txt.yujianweb.cn/ws';
export const ASR_TOKEN = process.env.VUE_APP_ASR_TOKEN || '144038';
